import React, { Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import DescriptionIcon from '@material-ui/icons/Description';
import ErrorIcon from '@material-ui/icons/Error';
import { get } from 'lodash';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  inline: {
    display: 'inline',
  },
  readColumn: {
    width: 40,
    marginTop: 30,
    fontSize: 8,
  },
  time: {
    display: 'block',
    marginTop: 4,
    color: theme.palette.text.secondary,
    fontSize: '0.75rem',
  },
  successAvatar: {
    backgroundColor: theme.palette.success.main,
  },
  errorAvatar: {
    backgroundColor: theme.palette.error.main,
  },
}));

export const RagProcessingNotification = ({ notification }) => {
  const classes = useStyles();
  const data = get(notification, 'data', {});
  const isSuccess = notification.action === 'rag_url_processing_complete';

  const message = isSuccess
    ? `Document processing complete: ${data.successful} of ${data.total} URL(s) processed successfully`
    : `Document processing failed: ${data.error || 'Unknown error'}`;

  return (
    <ListItem alignItems="flex-start">
      <ListItemText>
        {!get(notification, 'readAt') ? (
          <span className={classes.readColumn} role="img">
            &#128313;
          </span>
        ) : (
          <span className={classes.readColumn} role="img">
            &nbsp;
          </span>
        )}
      </ListItemText>
      <ListItemAvatar>
        <Avatar className={isSuccess ? classes.successAvatar : classes.errorAvatar}>
          {isSuccess ? <DescriptionIcon /> : <ErrorIcon />}
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={message}
        secondary={
          <Fragment>
            {data.titles && isSuccess && (
              <span style={{ display: 'block' }}>Documents: {data.titles}</span>
            )}
            <span className={classes.time}>
              {get(notification, 'createdAt') && moment(notification.createdAt).fromNow()}
            </span>
          </Fragment>
        }
      />
    </ListItem>
  );
};

export default RagProcessingNotification;
